import { Link, useParams, useLocation } from "react-router-dom";
import { buttonStyle } from '../libs/sharedStyles.js';
import { primaryButtonClasses } from '../libs/sharedClassNames.js';

import IntegrationScaffold from "../components/integrations/tabs/integrationScaffold.jsx";
import { integrationIds, getIntegration } from '../data/integrations.js';
import { useAuthContext } from '../contexts/AuthContext.jsx';

import Loading from '../components/Loading.jsx';
import NotFoundPage from "./404.jsx";

import { Suspense, useEffect, useState } from 'react';

export default function Integration() {
  const { currentOrganization } = useAuthContext();
  const { integrationId } = useParams();
  const [notFound, setNotFound] = useState(!integrationIds.includes(Number(integrationId)));
  const [connection, setConnection] = useState(null);
  const [integration, setIntegration] = useState(null);
  const { state } = useLocation();
  const initialTab = state?.tab || null;

  useEffect(() => {
    if (!notFound) {
      const srcIntegration = getIntegration(Number(integrationId));
      if (!srcIntegration) {
        setNotFound(true);
        return;
      }
      setIntegration(srcIntegration);
    }
  }, [integrationId]);

  useEffect(() => {
    const fetchConnection = async () => {
      const con = await integration.getEnrichedConnection(currentOrganization, integrationId);
      if (con) {
        const enriched = {
          integrationId: Number(integrationId),
          ...integration,
          ...con,
        };
        setConnection(enriched);
      } else {
        setNotFound(true);
      }
    };

    if (integration && currentOrganization) {
      fetchConnection();
    }
  }, [currentOrganization, integrationId, integration]);

  if (!connection && !notFound) {
    return <Loading />;
  }

  return (
    <Suspense fallback={<Loading />}>
      <div className="mx-auto max-w-[100rem] mb-10 pb-20">
        { notFound ? <NotFoundPage /> : <IntegrationScaffold integration={integration} connection={connection} initialTab={initialTab} /> }
        <div className="mt-10 mx-auto sm:px-6 lg:px-8">
          <Link to='/integrations'>
            <button style={buttonStyle} className={primaryButtonClasses}>
              &larr; Back to Integrations
            </button>
          </Link>
        </div>
      </div>
    </Suspense>
  );
}
